import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { PartnerOverviewData } from '../unpaid-partner-tile-summary.service';
import { UnpaidHubProductDefinition } from '../unpaid-payments-hub-overview.service';

@Component({
  selector: 'app-unpaid-payments-hub-product-card',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './unpaid-payments-hub-product-card.component.html',
})
export class UnpaidPaymentsHubProductCardComponent {
  @Input({ required: true }) product!: UnpaidHubProductDefinition;
  @Input() data: PartnerOverviewData | null = null;
  @Input() loading = false;
  @Input() unauthorized = false;

  @Output() cardClick = new EventEmitter<void>();

  get isDisabled(): boolean {
    return this.loading || this.unauthorized;
  }

  get hasUrgent(): boolean {
    return !this.unauthorized && (this.data?.urgentPaymentsCount ?? 0) > 0;
  }

  get hasUpcoming(): boolean {
    return !this.unauthorized && (this.data?.upcomingAmount ?? 0) > 0;
  }

  get showAmountToPay(): boolean {
    return this.product.key !== 'lendee';
  }

  onCardClick(): void {
    if (this.isDisabled) {
      return;
    }
    this.cardClick.emit();
  }
}
